dialogs-basic
  .modal.fade.show(role="dialog")
    .modal-dialog.modal-sm(role="document")
      .modal-content
        .modal-header
          h4.modal-title
            | { opts.title }
          button.close(aria-label="Close" data-dismiss="modal" type="button")
            span(aria-hidden="true")  ×
        .modal-body
          | { opts.body }
        .modal-footer
          | { opts.footer }
          button.btn.btn-default.waves-effect(data-dismiss="modal" type="button") Close
  script(type="typescript").
    this.mixin('base');
    this.watch();
